// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gEql","colBig":"styles_colBig__BZKdb","colSmall":"styles_colSmall__2g6AR"};